<template>
  <el-switch
    :value="row[prop]"
    :active-value="activeValue"
    :inactive-value="inactiveValue"
    @change="(e)=> { switchChange(e) }">
  </el-switch>
</template>
<script>
export default {
  name: 'ChangeStatus',
  props: {
    activeValue: { type: Number, default: 1 },
    inactiveValue: { type: Number, default: 0 },
    prop: { type: String, default: 'status' },
    idProp: { type: String, default: 'id' },
    title: { type: String, default: '状态' },
    enableApi: { type: Function, default() {} },
    disableApi: { type: Function, default() {} },
    row: { type: Object, default() { return {} } }
  },
  methods: {
    switchChange(e) {
      const title = e === this.activeValue ? '启用' : '禁用'
      this.$confirm(`此操作将${title}该${this.title}, 是否继续?`, '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
        .then(() => {
          this.$emit('handleLoading', true)
          const api = e === this.activeValue ? 'enableApi' : 'disableApi'
          this[api]({ [this.idProp]: this.row[this.idProp], [this.prop]: e })
            .then(res => {
              const { result, message } = res.data
              this.$emit('handleLoading', false)
              if ([0].includes(result)) {
                this.$message.success(`${title}${this.title}成功`)
                this.$emit('fetch')
              } else {
                this.$message.error(message)
              }
            })
            .catch(err => {
              this.$emit('handleLoading', false)
              this.$message.error(err.message)
            })
        })
    }
  }
}
</script>
